// extracted by mini-css-extract-plugin
export default {"mainWrapper":"StoreDetails_mainWrapper__DoRQA","mainContainer":"StoreDetails_mainContainer__6JzRB","title":"StoreDetails_title__Bx5r1","subTitle":"StoreDetails_subTitle__QE86J"};